import { FC } from 'react';
import { Flex } from '@chakra-ui/react';

import { BadgeListProps } from './types/BadgeListProps';

export const BadgeList: FC<BadgeListProps> = ({ gap = 2, children }) => (
  <Flex gap={gap} wrap="wrap">
    {children}
  </Flex>
);
